import * as yup from 'yup';
import { Liability } from '../../../CaseDetailsPage.types';
import { FormModel } from './Expenditure.types';
import { FIELDS } from 'modules/cm/fields/types';
import { nullableNumber, nullableString, positiveCurrencyIncludingZeroValidation } from 'utils/form/validation';
import { dateValidation } from 'utils/date';

const messages = {
  required: 'This field is required.',
};

export default yup.object().shape<FormModel>({
  [FIELDS.EXPENDITURES_PREFIX]: yup.array().of<Liability>(
    yup.object().shape({
      [FIELDS.EXPENDITURE_ID]: yup.number(),
      [FIELDS.EXPENDITURE_TYPE]: nullableString(),
      [FIELDS.EXPENDITURE_CREDIT_LIMIT]: positiveCurrencyIncludingZeroValidation(),
      [FIELDS.EXPENDITURE_BALANCE]: positiveCurrencyIncludingZeroValidation(),
      [FIELDS.EXPENDITURE_DESCRIPTION]: nullableString(),
      [FIELDS.EXPENDITURE_AMOUNT]: positiveCurrencyIncludingZeroValidation(),
      [FIELDS.EXPENDITURE_FREQUENCY]: nullableString(),
      [FIELDS.EXPENDITURE_END_DATE]: dateValidation().nullable(),
      [FIELDS.EXPENDITURE_TOTAL_NUMBER_OF_PROPERTIES]: nullableNumber(),
      [FIELDS.EXPENDITURE_WILL_BE_CLEARED_BY_LOAN]: yup.boolean().nullable(),
      [FIELDS.EXPENDITURE_WILL_BE_CLEARED_BEFORE_LOAN]: yup.boolean().nullable(),
    }),
  ),
  [FIELDS.MONTHLY_BASIC_SPEND]: positiveCurrencyIncludingZeroValidation(),
  [FIELDS.ANNUAL_COUNCIL_TAX]: nullableNumber().required(messages.required),
  [FIELDS.ANNUAL_GROUND_RENT]: nullableNumber(),
  [FIELDS.APPLICANT_NUMBER_OF_DEPENDANTS]: nullableNumber(),
});
